export enum Roles {
    ADMIN = 'admin',
    CLIENT = 'client',
    GUEST = 'guest',
    MANAGER='manager',
    MODERATOR='moderator'
}
